import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { RegionService } from 'src/app/services/region.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
  selector: 'app-transactionhistory-popup',
  templateUrl: './transactionhistory-popup.component.html',
  styleUrls: ['./transactionhistory-popup.component.scss'],
  providers: [DatePipe]
})
export class TransactionhistoryPopupComponent implements OnInit {

  id: number;
  routeParams: any;
  public fields: any[] = [];
  transactionHistoryDetail: any[];
  roleId: number;
  public chartdata: any;
  isApplicationPage: boolean = false;
  barToggle: number = 1;

  constructor(
    private sessionService: UserSessionService,
    private regionService: RegionService,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TransactionhistoryPopupComponent>,
    private paymentService: PaymentService,
  ) {
    this.roleId = this.sessionService.roleId();
  }

  ngOnInit() {
    if (this.data.application_id) {
      this.isApplicationPage = true;
      this.getMinesTransactionHistory();
    } else if (this.data.permit_id) {
      this.getTransactionHistory()
    }
  }

  getTransactionHistory() {
    let data = {
      permit_id: this.data.permit_id,
      fees_id: this.data.fees_id
    }
    this.transactionHistoryDetail = [];
    this.regionService.getTransactionHistory(data).subscribe(result => {
      if (result && result.isSuccess) {
        this.transactionHistoryDetail = [];
        this.transactionHistoryDetail = result.Data;
        // this.transactionHistoryDetail = _.orderBy(this.transactionHistoryDetail,['created_at'],['desc']);
        this.transactionHistoryDetail.forEach((s) => {
          s.created_at_display = moment(s.created_at).format('DD-MM-YYYY HH:mm');
          s.amount = Number(s.amount)
          s.displayAmount = s.amount.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          });
          if (s.bank_status) {
            if (s.bank_status.toLowerCase() == 'failure') {
              s.colorcode = {
                background_color: 'red',
                text_color: 'white'
              }
            } else if (s.bank_status.toLowerCase() == 'success') {
              s.colorcode = {
                background_color: 'green',
                text_color: 'white'
              }
            } else if (s.bank_status.toLowerCase() == 'pending') {
              s.colorcode = {
                background_color: 'orange',
                text_color: 'white'
              }
            } else if (s.bank_status.toLowerCase() == 'initiated') {
              s.colorcode = {
                background_color: 'grey',
                text_color: 'white'
              }
            }
          }
        });
      } else {
        if (result.failures) {
          this.alertService.error(result.failures.toString());
        }
      }
    })
  }

  getMinesTransactionHistory() {
    this.transactionHistoryDetail = [];
    this.regionService.getMinesTransactionHistory(this.data).subscribe(result => {
      if (result && result.isSuccess) {
        this.transactionHistoryDetail = [];
        this.transactionHistoryDetail = result.Data;
        // this.transactionHistoryDetail = _.orderBy(this.transactionHistoryDetail,['created_at'],['desc']);
        this.transactionHistoryDetail.forEach((s) => {
          s.created_at_display = moment(s.created_at).format('DD-MM-YYYY HH:mm');
          s.amount = Number(s.amount)
          s.displayAmount = s.amount.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          });
          if (s.bank_status) {
            if (s.bank_status.toLowerCase() == 'failure') {
              s.colorcode = {
                background_color: 'red',
                text_color: 'white'
              }
            } else if (s.bank_status.toLowerCase() == 'success') {
              s.colorcode = {
                background_color: 'green',
                text_color: 'white'
              }
            } else if (s.bank_status.toLowerCase() == 'pending') {
              s.colorcode = {
                background_color: 'orange',
                text_color: 'white'
              }
            } else if (s.bank_status.toLowerCase() == 'initiated') {
              s.colorcode = {
                background_color: 'grey',
                text_color: 'white'
              }
            }
          }
        });
      } else {
        if (result.failures) {
          this.alertService.error(result.failures.toString());
        }
      }
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  downloadIFHRMChallan(challan_num: any) {

    let data = {
      "ref_no": challan_num.dept_tran_ref_no,
      "payment_type": challan_num.payment_type2
    }

    this.paymentService.downloadChallan(data).subscribe(res => {
      window.open(res.url);
    })
    // window.open(`${environment.karuvoolamBaseUrl}/challan/echallan/download/` + challan_num, '_blank');
  }

  filterChange(barToggle: number) {
    this.barToggle = barToggle;

    if (barToggle == 1) {
      this.getMinesTransactionHistory();
    }
    else if (barToggle == 2) {
      if (this.data?.permit_id) {
        this.getTransactionHistory();
      }
      else {
        this.transactionHistoryDetail = [];
      }
    }
  }

}
